import { extendObservable, action } from 'mobx';

import DeliveryApi from '../psuite-js/apis/delivery/delivery';

class DeliveryStore {

    constructor() {
        extendObservable(this, {
            deliveries: [],

            fetching: false,
            creating: false,
            updating: false,
            removing: false,

            is_fetched: false,
            fetch: action(this.fetch.bind(this)),
            create: action(this.create.bind(this)),
            update: action(this.update.bind(this)),
            remove: action(this.remove.bind(this)),
        });
    }

    getIndexById(delivery_uid) {
        const deliveries = this.deliveries;
        return deliveries.findIndex(delivery => delivery.uid === delivery_uid);
    }

    async fetch(params) {
        this.fetching = true;

        const response = await DeliveryApi.all(params);

        if (response.status === 200) {

            const deliveries = response.data.data;

            this.deliveries = deliveries;
            this.deliveries_by_vehicles = this.groupDeliveriesByVehicles(deliveries);

            this.is_fetched = true;
        }

        this.fetching = false;
        return response;
    }

    groupDeliveriesByVehicles(items) {
        let vehicles = [];
        let i = 0;
        let vehicle_id = null;

        items.forEach((item) => {
            const vehicle = item.vehicle;

            vehicles[i] = vehicles[i] || {
                id: item.vehicle_id,
                delivery_type: item.delivery_type,
                vehicle_type: vehicle.vehicle_type || {},
                vehicle_contract: vehicle.vehicle_contract || {},
                user: vehicle.user || {},
                payload: item.payload || {},
                deliveries: {total: 0, done: 0, percent: '100'},
                returns: '0',
                has_sequence_change: false,
                customers: []
            };

            const customer = item.customer || {};

            customer.status = item.status;
            customer.planned_sequence = item.planned_sequence;
            customer.sequence = item.sequence;

            vehicles[i].deliveries.total = vehicles[i].deliveries.total + 1;

            if (item.status !== 'pending') {
                vehicles[i].deliveries.done = vehicles[i].deliveries.done + 1;
            }

            const percent = vehicles[i].deliveries.done * 100 / vehicles[i].deliveries.total;
            vehicles[i].deliveries.percent = percent;
            // customer.delivery_date = item.date;

            vehicles[i].customers.push({...customer});

            if (vehicle_id === item.vehicle_id) {
                i++;
            }

            vehicle_id = item.vehicle_id;
        });

        return vehicles;
    }

    getVehicleDeliveries(vehicle_id) {
        return this.deliveries_by_vehicles.find(vehicle => vehicle.id === vehicle_id);
    }

    async create(delivery, callback = () => {}) {
        this.creating = true;

        const response = await DeliveryApi.create(delivery);

        if (response.status === 200) {
            this.deliveries.push(response.data);
        }

        this.creating = false;

        return response;
    }

    async update(uid, delivery) {
        this.updating = true;

        const response = await DeliveryApi.update(uid, delivery);

        if (response.status === 200) {
            const index = this.getIndexById(uid);
            this.deliveries[index] = {...this.deliveries[index], ...delivery};
        }

        this.updating = false;
        return response;
    }

    async remove(delivery) {
        this.removing = true;

        const response = await DeliveryApi.delete(delivery.uid);

        if (response.status === 200) {
            const uid = delivery.uid;
            this.deliveries = this.deliveries.filter(delivery => delivery.uid !== uid);
        }

        this.removing = false;
        return response;
    }

}

export default new DeliveryStore();



// WEBPACK FOOTER //
// ./src/stores/delivery.js